
import { defineComponent, reactive, toRef, ref, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import { useLazyQuery } from "@vue/apollo-composable";
import { peperiksaanBorangView } from "@/apollo/peperiksaan";
export default defineComponent({
  name: "display-modal",
  props:{permohonan:Object},
  methods:{
        formatDate(date) {
      moment.locale('ms');

      return moment(date).format("DD MMMM YYYY");
    },
  },
  setup(props){
    const peperiksaan = ref({});
    const permohonan = toRef(props, "permohonan");
    let variables = reactive({
      id:parseFloat(permohonan.value?.id)
    });
    watch(permohonan,()=>{
      load();
      variables.id = parseFloat(permohonan.value?.id)
      refetch();
    });
        const {
      result: PeperiksaanMohonList,
      refetch,
      load,
      onResult,
    } = useLazyQuery(peperiksaanBorangView, variables, {
      fetchPolicy: "network-only",
    });
    
    return{
      peperiksaan
    }
  }
});
